<form #contactForm="ngForm" class="contact-card">
  @if (contactMode === 'phone') {
  <div class="input-section"
       [ngClass]="{'has-error': isPhoneInvalid}">
    <div class="label-row">
      <label for="phoneNumber" class="input-label">
        {{ 'web.purchasePhoneNumber' | translate }}
      </label>
      <button type="button"
              class="switch-link"
              (click)="switchMode('email')">
        {{ 'web.purchaseChangeToEmail' | translate }}
      </button>
    </div>
    <div class="phone-input-wrapper">
      <input type="tel"
             id="countryCode"
             class="country-code-input"
             name="countryCode"
             [(ngModel)]="countryCode"
             [attr.aria-label]="'web.countryCode' | translate"
             (ngModelChange)="validateContactControl()"
             #countryCodeModel="ngModel"
             placeholder="+45"
             required />
      <input type="tel"
             id="phoneNumber"
             class="phone-input"
             name="phoneNumber"
             [(ngModel)]="phoneNumber"
             [attr.aria-describedby]="isPhoneInvalid ? 'phoneError' : null"
             (ngModelChange)="validateContactControl()"
             (keydown.enter)="hideKeyboard(phoneNumberInput)"
             #phoneModel="ngModel"
             #phoneNumberInput
             placeholder="{{ 'web.purchasePhoneNumberPlaceHolder' | translate }}"
             required />
    </div>
    @if (isPhoneInvalid) {
    <div id="phoneError" class="error-message" role="alert">
      {{ 'web.invalidPhoneNumber' | translate }}
    </div>
    }
  </div>
  }
  @if (contactMode === 'email') {
  <div class="input-section"
       [ngClass]="{'has-error': isEmailInvalid}">
    <div class="label-row">
      <label for="emailAddress" class="input-label">{{ 'web.purchaseEmail' | translate }}</label>
      <button type="button"
              class="switch-link"
              (click)="switchMode('phone')">
        {{ 'web.purchaseChangeToPhoneNumber' | translate }}
      </button>
    </div>
    <input type="email"
           id="emailAddress"
           class="email-input"
           name="emailAddress"
           placeholder="{{ 'web.purchaseEmailPlaceHolder' | translate }}"
           [(ngModel)]="emailAddress"
           (keydown.enter)="hideKeyboard(emailInput)"
           [attr.aria-describedby]="isEmailInvalid ? 'emailError' : null"
           (ngModelChange)="validateContactControl()"
           #emailModel="ngModel"
           pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$"
           email
           #emailInput
           required />
    @if (isEmailInvalid) {
    <div id="emailError" class="error-message" role="alert">
      {{ 'web.invalidEmail' | translate }}
    </div>
    }
  </div>
  }
</form>
